export default "<div class=\"label-read-only\">{{label ? (label + ': ') : '&nbsp;'}}</div>\r\n<div class=\"data-read-only\">{{getText()}}</div>\r\n";